var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_10429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87501 2.04125C-0.482495 4.49 4.93228e-06 7.09125 4.93228e-06 14.9937C4.93228e-06 21.5562 -1.145 28.135 4.84751 29.6837C6.71875 30.165 23.2988 30.165 25.1675 29.6812C27.6625 29.0375 29.6925 27.0137 29.97 23.485C30.0088 22.9925 30.0088 7.00375 29.9688 6.50125C29.6738 2.7425 27.36 0.576247 24.3113 0.137497C23.6125 0.036247 23.4725 0.00624696 19.8875 -3.03984e-06C7.17125 0.00624696 4.38375 -0.560003 1.87501 2.04125Z",
    fill: "url(#paint0_linear_1660_10429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9975 3.92378C10.4588 3.92378 6.14876 3.52003 4.50251 7.74503C3.82251 9.49003 3.92126 11.7563 3.92126 15.0013C3.92126 17.8488 3.83001 20.525 4.50251 22.2563C6.14501 26.4838 10.49 26.0788 14.995 26.0788C19.3413 26.0788 23.8225 26.5313 25.4888 22.2563C26.17 20.4938 26.07 18.2613 26.07 15.0013C26.07 10.6738 26.3088 7.88003 24.21 5.78253C22.085 3.65753 19.2113 3.92378 14.9925 3.92378H14.9975ZM14.005 5.92003C23.4725 5.90503 24.6775 4.85253 24.0125 19.4738C23.7763 24.645 19.8388 24.0775 14.9988 24.0775C6.17376 24.0775 5.92001 23.825 5.92001 14.9963C5.92001 6.06503 6.62001 5.92503 14.005 5.91753V5.92003ZM20.91 7.75878C20.5576 7.75878 20.2196 7.89877 19.9704 8.14796C19.7213 8.39715 19.5813 8.73512 19.5813 9.08753C19.5813 9.43993 19.7213 9.77791 19.9704 10.0271C20.2196 10.2763 20.5576 10.4163 20.91 10.4163C21.2624 10.4163 21.6004 10.2763 21.8496 10.0271C22.0988 9.77791 22.2388 9.43993 22.2388 9.08753C22.2388 8.73512 22.0988 8.39715 21.8496 8.14796C21.6004 7.89877 21.2624 7.75878 20.91 7.75878ZM14.9975 9.31253C14.2505 9.31261 13.5109 9.45982 12.8208 9.74575C12.1307 10.0317 11.5037 10.4507 10.9756 10.979C9.90897 12.0458 9.30985 13.4927 9.31001 15.0013C9.31018 16.5099 9.90962 17.9566 10.9765 19.0232C12.0433 20.0898 13.4902 20.6889 14.9988 20.6888C16.5073 20.6886 17.9541 20.0892 19.0207 19.0223C20.0873 17.9555 20.6864 16.5086 20.6863 15C20.6861 13.4914 20.0867 12.0447 19.0198 10.9781C17.953 9.91149 16.5061 9.31236 14.9975 9.31253ZM14.9975 11.3088C19.8788 11.3088 19.885 18.6938 14.9975 18.6938C10.1175 18.6938 10.11 11.3088 14.9975 11.3088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_10429",
    x1: 1.93253,
    y1: 28.0839,
    x2: 29.8144,
    y2: 3.95247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_10429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.6abee76017966362689214ef347518f4.svg";
export { ForwardRef as ReactComponent };